import { useFeed } from './useFeed';
import { subscribeLists } from '../data/lists';

const NO_DOCS = [];

/**
 * Live docs of the lists staff manage in the app (custom lists, restyled built-ins,
 * item routes, tombstones). On error (offline first load, rules not yet deployed) the
 * board keeps working with the built-in lists, and the feed re-opens by itself (useFeed).
 * Every caller shares ONE listener (data/liveFeed.js).
 */
export function useListDocs() {
  const { data, loading, error } = useFeed('lists', subscribeLists, { initial: NO_DOCS });
  return { docs: data, ready: !loading, error: error ? (error.code || error.message || 'error') : '' };
}
